/**
 * AI Interview Practice System - Entry Point
 *
 * Copyright (c) 2024 Technical Interviewer Attempt. All Rights Reserved.
 * Proprietary and Confidential. Unauthorized copying, distribution, or use is prohibited.
 */

import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  // StrictMode disabled to prevent duplicate WebSocket connections in development
  // Re-enable in production if needed, but be aware it causes double-invocation of effects
  <App />
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
);
